import { IDeleteHospitalAction, IDeleteHospitalParams } from './deleteHospital.interface';
import { DeleteHospitalTypes } from './deleteHospital.type';

export const deleteHospital = (payload: IDeleteHospitalParams): IDeleteHospitalAction => ({
	type: DeleteHospitalTypes.DELETE_HOSPITAL,
	payload,
});
